// Script loader that respects cookie consent

import { hasSpecificConsent, CONSENT_LEVELS } from './cookieUtils';

// Essential scripts (always loaded)
const ESSENTIAL_SCRIPTS = [
  '/js/jquery-3.4.1.min.js',
  '/js/bootstrap.min.js',
  '/js/custom.js'
];

// Non-essential scripts (require consent)
const NON_ESSENTIAL_SCRIPTS = [
  // Future: Add analytics, marketing scripts here
  // 'https://www.googletagmanager.com/gtag/js?id=GA_MEASUREMENT_ID',
  // 'https://connect.facebook.net/en_US/fbevents.js'
];

// Load essential scripts immediately
export const loadEssentialScripts = () => {
  ESSENTIAL_SCRIPTS.forEach(scriptSrc => {
    if (!document.querySelector(`script[src="${scriptSrc}"]`)) {
      const script = document.createElement('script');
      script.src = scriptSrc;
      script.async = false;
      document.body.appendChild(script);
    }
  });
};

// Load non-essential scripts only with consent
export const loadNonEssentialScripts = () => {
  if (!hasSpecificConsent(CONSENT_LEVELS.ALL)) {
    console.log('Non-essential scripts blocked - no consent given');
    return;
  }

  NON_ESSENTIAL_SCRIPTS.forEach(scriptSrc => {
    if (!document.querySelector(`script[src="${scriptSrc}"]`)) {
      const script = document.createElement('script');
      script.src = scriptSrc;
      script.async = true;
      document.body.appendChild(script);
    }
  });
};

// Block non-essential scripts
export const blockNonEssentialScripts = () => {
  // Remove any non-essential scripts that might have been loaded
  NON_ESSENTIAL_SCRIPTS.forEach(scriptSrc => {
    const script = document.querySelector(`script[src="${scriptSrc}"]`);
    if (script) {
      script.remove();
    }
  });
  
  // Block tracking functions
  if (window.gtag) {
    window.gtag = () => {};
  }
  
  if (window.fbq) {
    window.fbq = () => {};
  }
  
  if (window.dataLayer) {
    window.dataLayer = [];
  }
};

// Initialize script loading based on current consent
export const initializeScripts = () => {
  loadEssentialScripts();
  
  if (hasSpecificConsent(CONSENT_LEVELS.ALL)) {
    loadNonEssentialScripts();
  } else {
    blockNonEssentialScripts();
  }
};
